<template>
    <div class="page-table tabStyle scrollable mainDiv" id="affix-container">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.urun.opsiyon.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.urun.opsiyon.tanimlama.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.opsiyon.tanimlama.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="urunOpsiyon" :rules="rulesUrunOpsiyon" ref="urunOpsiyon"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.baslik")'
                                              prop="baslik">:
                                    <el-input
                                            v-model="urunOpsiyon.baslik"
                                            :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                              prop="dil.en.baslik">:
                                    <el-input
                                            v-model="urunOpsiyon.dil.en.baslik"
                                            :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.de.baslik")'
                                              prop="dil.de.baslik">:
                                    <el-input
                                            v-model="urunOpsiyon.dil.de.baslik"
                                            :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                        <el-collapse-item title="Katogori Ayarları" name="4">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="kategoriList">
                                        <el-transfer
                                                style="text-align: left; display: inline-block"
                                                v-model="urunOpsiyon.kategori"
                                                filterable
                                                :titles="['Kategori Listesi', 'Seçilen Kategoriler']"
                                                :format="{
                                                    noChecked: '${total}',
                                                    hasChecked: '${checked}/${total}'
                                                 }"
                                                @change="kategoriChange"
                                                :data="kategoriListesi">
                                        </el-transfer>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.urun.opsiyon.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select
                                                v-model="urunOpsiyon.durum"
                                                style="width: 100%">
                                            <el-option value="0" label="Taslak">Taslak</el-option>
                                            <el-option value="1" label="Yayınla">Yayınla</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini"
                                        v-on:click="urunOpsiyonTanimlama('urunOpsiyon',urunOpsiyon.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="urunOpsiyon.durum === '1'">{{$t('src.views.apps.urun.opsiyon.tanimlama.urunOpsiyonEkle')}}</label>
                                    <label v-else>Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.urun.opsiyon.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('urunOpsiyon')">
                                            {{$t('src.views.apps.urun.opsiyon.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.urun.opsiyon.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.urun.opsiyon.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip :content="$t('src.views.apps.urun.opsiyon.tanimlama.copKutusu')"
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button class="cop" v-on:click="urunOpsiyonTanimlama('urunOpsiyon','0')"
                                               type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.urun.opsiyon.tanimlama.yapiskan")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="yapiskan">
                                        <el-switch
                                                v-model="urunOpsiyon.yapiskan"
                                                active-value="1"
                                                inactive-value="0"
                                                active-text="Sabitle"
                                                inactive-text="Sabitleme">
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.urun.opsiyon.tanimlama.konum")' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="konum">
                                        <el-button type="primary" size="mini" @click="dialogKonum = true">
                                            {{this.konumText}}
                                        </el-button>
                                        &nbsp;
                                        <img v-if="urunOpsiyon.konum === '0'" style="float: right"
                                             src="../../../../assets/images/13.png" width="40%" height="40%">
                                        <img v-if="urunOpsiyon.konum === '1'" style="float: right"
                                             src="../../../../assets/images/14.png" width="40%" height="40%">
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title="Opsiyon Konumu"
                    :visible.sync="dialogKonum"
                    width="50%">
                <el-row>
                    <el-col :span="12">
                        <el-radio v-model="urunOpsiyon.konum" label="0" @change="changeKonum('0')">
                            <img src="../../../../assets/images/13.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="12">
                        <el-radio v-model="urunOpsiyon.konum" label="1" @change="changeKonum('1')">
                            <img src="../../../../assets/images/14.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import urunService from '../../../../WSProvider/UrunService'
    import status from '../../../../status'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataArtdoor = "";
    export default {
        name: "OpsiyonTanimla",
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                this.getKategoriListesi();
            }
        },
        data() {
            return {
                dialogKonum: false,
                konumText: "Seç",
                kategoriListesi: [],
                activeCollapse: ['1', '2', '3', '4', '5'],
                visibleSil: false,
                urunOpsiyon: {
                    baslik: "",
                    kategoriList: [],
                    yapiskan: '0',
                    durum: "1",
                    konum: "1",
                    dil: {
                        en: {
                            baslik: '',
                        },
                        de: {
                            baslik: '',
                        }
                    }
                },
                rulesUrunOpsiyon: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                },
            }
        },
        methods: {
            kategoriChange(value) {
                this.urunOpsiyon.kategoriList = value;
            },
            // inputStyle(val, form) {
            //     var splitStr = val.toLowerCase().split(' ');
            //     for (var i = 0; i < splitStr.length; i++) {
            //         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            //     }
            //     this.urunOpsiyon[form] = splitStr.join(' ');
            // },
            getKategoriListesi() {
                let self = this;
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            self.kategoriListesi.push({
                                key: e.urunKategoriKodu,
                                label: e.baslik,
                            });
                        })
                    } else {
                        status.Status(response.status, this)
                    }
                })
            },
            urunOpsiyonTanimlama(formName) {
                let self = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let dil = {
                            en: {
                                baslik: this.urunOpsiyon.dil.en.baslik,
                            },
                            de: {
                                baslik: this.urunOpsiyon.dil.de.baslik,
                            }
                        };
                        urunService.urunOpsiyonTanimlama(this.urunOpsiyon.baslik, this.urunOpsiyon.yapiskan, this.urunOpsiyon.konum, this.urunOpsiyon.durum, dil, this.urunOpsiyon.kategoriList).then((response) => {
                            if (response.status === 200) {
                                status.Status('success', this, 'Opsiyon başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                status.Status('warning', this, 'Bu bilgiler ile kayıtlı bir opsiyon zaten mevcut');
                            } else {
                                status.Status(response.status, this)
                            }
                        })
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
            },
            changeKonum(konum) {
                this.dialogKonum = false;
                this.konumText = "Değiştir";
                switch (konum) {
                    case '0' :
                        status.Status('success', this, 'Opsiyon konumu "Tab" olarak seçildi.');
                        break;
                    case '1' :
                        status.Status('success', this, 'Opsiyon konumu "Sağ" olarak seçildi.');
                        break;
                }

            }

        }
    }
</script>
<style scoped>
    #affix-container.tabStyle {
        position: relative;
        padding-left: 55px;
        left: -30px;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }
</style>
<style lang="scss" scoped>
    @import '../../../../assets/scss/_variables';

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>